const APP_VERSION_QUERY_KEY = "__kenpost_version";
const APP_REFRESH_QUERY_KEY = "__kenpost_refresh";

export function isSameAppVersion(currentVersion: string, candidateVersion: string) {
  const current = currentVersion.trim();
  const candidate = candidateVersion.trim();
  if (!current || !candidate) return false;
  if (current === candidate) return true;

  const gitCommitPattern = /^[0-9a-f]{7,40}$/i;
  if (!gitCommitPattern.test(current) || !gitCommitPattern.test(candidate)) return false;
  const shorter = current.length <= candidate.length ? current : candidate;
  const longer = current.length > candidate.length ? current : candidate;
  return longer.toLowerCase().startsWith(shorter.toLowerCase());
}

export function buildAppVersionRefreshUrl(currentHref: string, targetVersion: string, refreshNonce = Date.now()) {
  const url = new URL(currentHref);
  url.searchParams.set(APP_VERSION_QUERY_KEY, targetVersion.trim());
  url.searchParams.set(APP_REFRESH_QUERY_KEY, String(refreshNonce));
  return url.toString();
}
